import CreateIcon from '@material-ui/icons/CreateOutlined'
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow'
import DvrIcon from '@material-ui/icons/DvrOutlined'
import EqualizerIcon from '@material-ui/icons/Equalizer'
import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy'
import SettingsIcon from '@material-ui/icons/Settings'
import BookIcon from '@material-ui/icons/Book'
import DashboardIcon from '@material-ui/icons/Dashboard'
import GraphicEqIcon from '@material-ui/icons/GraphicEq'
import SpellcheckIcon from '@material-ui/icons/Spellcheck'
import FolderIcon from '@material-ui/icons/Folder'

import {
    GENERAL_SETTINGS,
    MEMSOURCE_PROJECTS_LIST_PATH,
    TEMPO_DASHBOARD_PATH,
    TEMPO_PROJECTS_LIST_PATH,
    TEMPO_QUOTES_LIST_PATH,
    TEMPO_REPORTING_PATH,
    TEMPO_STUDIES_PATH,
    TEMPO_TERMINOLOGY_PATH,
    TEMPO_VALIDATION_PATH,
    XTRF_PROJECTS_LIST_PATH,
    XTRF_PROJECTS_NEW_PATH,
    XTRF_QUOTE_LIST_PATH,
    XTRF_REPORTS_PATH,
} from './pathList'
import { NavigationConfig } from '../interfaces/NavigationConfig'
import {
    PERMISSION_TEMPO_CREATE_REQUEST,
    PERMISSION_TEMPO_SETTINGS,
    PERMISSION_TEMPO_SHOW_PROJECT_LIST,
    PERMISSION_TEMPO_SHOW_REPORTING,
    PERMISSION_TEMPO_TERMINOLOGY,
    PERMISSION_TEMPO_VALIDATE,
} from '../helpers/functions/rolesAndPermissions'
import { Providers } from '../interfaces/Providers'

export default <NavigationConfig[]>[
    {
        title: 'navigation.left_bar.new_project',
        href: XTRF_PROJECTS_NEW_PATH,
        icon: CreateIcon,
        type: Providers.xtrf,
    },
    {
        title: 'navigation.left_bar.list',
        href: '/list',
        icon: DoubleArrowIcon,
        type: Providers.xtrf,
        children: [
            {
                title: 'navigation.left_bar.projects',
                href: XTRF_PROJECTS_LIST_PATH,
                type: Providers.xtrf,
            },
            {
                title: 'navigation.left_bar.quotes',
                href: XTRF_QUOTE_LIST_PATH,
                type: Providers.xtrf,
            },
        ],
    },
    {
        title: 'navigation.left_bar.report',
        href: XTRF_REPORTS_PATH,
        icon: EqualizerIcon,
        type: Providers.xtrf,
    },
    {
        title: 'navigation.left_bar.projects_monitoring',
        href: MEMSOURCE_PROJECTS_LIST_PATH,
        icon: DvrIcon,
        type: Providers.memsource,
    },
    {
        title: 'navigation.left_bar.tempo.dashboard',
        href: TEMPO_DASHBOARD_PATH,
        icon: DashboardIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.tempo.requests',
        href: TEMPO_QUOTES_LIST_PATH,
        permission: PERMISSION_TEMPO_CREATE_REQUEST,
        icon: CreateIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.projects',
        href: TEMPO_PROJECTS_LIST_PATH,
        permission: PERMISSION_TEMPO_SHOW_PROJECT_LIST,
        type: Providers.tempo,
        icon: FolderIcon,
    },
    {
        title: 'navigation.left_bar.tempo.validation',
        href: TEMPO_VALIDATION_PATH,
        permission: PERMISSION_TEMPO_VALIDATE,
        icon: SpellcheckIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.tempo.terminology',
        href: TEMPO_TERMINOLOGY_PATH,
        permission: PERMISSION_TEMPO_TERMINOLOGY,
        icon: BookIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.tempo.reporting',
        href: TEMPO_REPORTING_PATH,
        permission: PERMISSION_TEMPO_SHOW_REPORTING,
        icon: GraphicEqIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.tempo.settings',
        href: GENERAL_SETTINGS,
        permission: PERMISSION_TEMPO_SETTINGS,
        icon: SettingsIcon,
        type: Providers.tempo,
    },
    {
        title: 'navigation.left_bar.studies',
        href: TEMPO_STUDIES_PATH,
        icon: LocalPharmacyIcon,
        type: Providers.tempo,
    },
]
